import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Divider } from '@material-ui/core';
import UserApi from '../../api/Scoreboardapi';
import { Link } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import NativeSelect from '@material-ui/core/NativeSelect';
import FormControl from '@material-ui/core/FormControl';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InputBase from '@material-ui/core/InputBase';
import MaterialTable, { MTableAction } from "material-table";
import Footer from '../auth/Footer';
import { Helmet } from 'react-helmet'
import moment from 'moment';

import MenuLeftNav from './MenuLeftNav';
import { checkModulePermission } from "../../crud/auth.crud";

library.add(fas)

// Styles
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

class TransactionLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionList: [],
            currentPage: 1,
            currentSortOrder: {defaultSort: 'desc'},
            sortBy: "created_at",
            isLoading: false,
            nameSort: {},
            textToSearch: '',
            rowsPerPage: 10,
            totalRecords: 10,
            rowsToSkip: 0,
            alert: '',
            hidepageination : false,
            showModal: false,
        };
        this.viewCommand = this.viewCommand.bind(this);
    }

    componentDidMount = async () => {
        this.GetTransactionList()
    }

    GetTransactionList = async () => {
        this.setState({ isLoading: true })
        const options = {
            params: {
                    "OrderByFieldParam": this.state.sortBy,
                    "SortOrderParam": this.state.currentSortOrder.defaultSort,
                    "PageSize": this.state.rowsPerPage,
                    "RowsToSkip": this.state.rowsToSkip
                },
        };

        await UserApi.get(`transactionlog/gettransationlog`, options)
            .then(res => {
            if(res.data.success ==true){
            this.setState({
                isLoading:false,
                transactionList:res.data.liTransactionLogResponse,
                hidepageination :true,
                totalRecords:res.data.listCount
                })
            }
            else {
            this.setState({
                isLoading:false,
                userList:[],
                totalRecords:0
                })
            }
            })
            .catch(error => {this.setState({isLoading:false, liTransactionLogResponse:[],totalRecords:0}); console.log(error.response)});
    }

    viewCommand = (rowData, event) => {
        const getAlert = () => (
            <SweetAlert
                // warning
                customClass='user-sweetalert transaction'
                title={"Transaction for "+rowData.userName+" @"+rowData.action}
                onConfirm={() => this.hideModel()}>
                <code>{rowData.sqlCommand}</code>
            </SweetAlert>
        )

        this.setState({
            alert:getAlert(),
            showModal: ! this.state.showModal,
        })
    };

    hideModel = () => {
        this.setState({
            alert: '',
            showModal: ! this.state.showModal,
        })
    }

    // changeSearch = async (event) => {
    //     console.log("event.target.value", event.target.value)
    //     if(!event.target.value || event.target.value =='' || (event.target.value && event.target.value.length >3)) {
    //         await this.setState({ textToSearch: event.target.value, rowsToSkip: 0 });
    //         await this.GetTransactionList()
    //     }
    // }

    changePage = async (event) => {
        await this.setState({
            currentPage: event + 1,
            rowsToSkip: parseInt(event) > 0 ? parseInt(event) * parseInt(this.state.rowsPerPage) : 0
        });
        this.GetTransactionList()
    }

    changeOrderBy = async (orderedColumnId, orderDirection) => {
        let columns = {
                        0: 'userID',
                        1: 'userName',
                        2: 'pageName',
                        3: 'action',
                        4: 'ipAddress',
                        5: 'sqlCommand',
                        6: 'created_at',
                    }

        if (orderDirection) {
            this.setState({sortBy: columns[orderedColumnId], currentSortOrder: { defaultSort: orderDirection }  },() => {
                this.GetTransactionList();
            })
        }
    }

    changeRowsPerPage = async (event) => {
        await this.setState({ rowsPerPage: event });
    }

    displayAlert = (title, message, type, userid, isDelete = true) => {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => ( < SweetAlert
                success
                customClass='user-sweetalert'
                title={title}
                onConfirm={() => this.hideModel()} >
                {message}
                </SweetAlert>
            )
        }
        else if (type == 'deleteConfirmation') {
            getAlert = () => ( <SweetAlert
                warning
                showCancel
                customClass='user-sweetalert'
                confirmBtnText={isDelete ? 'Yes, Delete it!' : "Yes, restore it!"}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"

                title={title}
                onConfirm={() => this.deleteOrRestoreUser(userid, isDelete ? 'delete' : 'restore')}
                onCancel={() => this.hideModel()}
                focusCancelBtn >
                {message}
                </SweetAlert>)
        }
        else {
            getAlert = () => ( < SweetAlert
                error
                customClass='user-sweetalert'
                title={title}
                onConfirm={() => this.hideModel()} >
                {message}
                </SweetAlert>)
        }

        this.setState({
            alert: getAlert(),
            showModal: ! this.state.showModal
        });
    }

    render() {
        const { showModal } = this.state;

        return (
          <>
            {
              showModal ? (
                <Modal>
                    {this.state.alert}
                </Modal>
              ) : null
            }

            <Helmet>
                <title>Transaction Log List | Scorecard</title>
            </Helmet>
            <div className="main-content-body UserList">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 left-side-bar">
                            <MenuLeftNav isExpand={{ expand: "transaction", active: "transaction" }}></MenuLeftNav>
                        </div>
                        <div className="col-lg-9 mt-3 right-content-wrap  mb-5">
                            <div className="order-and-adherence-detail">
                                <span className="manage-user-title">Manage Transaction Logs</span>
                                <div className="font-500 user-list-table">
                                    <div className="form-inline p-3 jc-between" style={{ height: '65px' }}>
                                        <div>
                                            <span className="ml-2 font-500">Transaction Log Listing</span>
                                        </div>
                                        {/* <div className="user-add-btn">
                                            <input type="text" placeholder="Enter 4 characters to search..." onChange={this.changeSearch} className="form-control mb-3" style={{ width: '230px' }} />
                                            {checkModulePermission("add-user") === true &&
                                            <Link className="btn btn-primary btn-elevate kt-cancel__btn-primary add-user-btn" to="/user/create">
                                                <FontAwesomeIcon icon={["fas", "plus"]} color="white" /> Add User
                                            </Link>}
                                        </div> */}
                                    </div>
                                    <Divider />
                                    <div className="row p-3">
                                        <div className="col-lg-12">
                                            <div style={{ maxWidth: '100%' }}>
                                                <MaterialTable
                                                    icons={tableIcons}
                                                    onChangePage={this.changePage}
                                                    onOrderChange={this.changeOrderBy}
                                                    onChangeRowsPerPage={this.changeRowsPerPage}
                                                    className="client-listing"
                                                    columns=
                                                    {[
                                                        { title: 'User ID', field: 'userID', width: 20},
                                                        { title: 'User Name', field: 'userName',
                                                            render: rowData => {
                                                                return rowData.userName ? rowData.userName : '-';
                                                            },
                                                        },
                                                        { title: 'Page Name', field: 'pageName',
                                                            render: rowData => {
                                                                return rowData.pageName ? rowData.pageName : '-';
                                                            },
                                                        },
                                                        { title: 'Action', field: 'action',
                                                            render: rowData => {
                                                                return rowData.action ? rowData.action : '-';
                                                            },
                                                        },
                                                        { title: 'IP Address', field: 'ipAddress',
                                                            render: rowData => {
                                                                return rowData.ipAddress ? rowData.ipAddress : '-';
                                                            },
                                                        },
                                                        { title: 'SQl Command', field: 'sqlCommand', sorting:false, render: rowData => <>{ rowData.sqlCommand ? <a style={{color: "#5867dd !important"}} href='#' onClick={(e) => this.viewCommand(rowData, e)}>view sql command </a> :'-'}</>},
                                                        { title: 'Create Date', field: 'createdDate',...this.state.currentSortOrder,  render:rowData => {
                                                            return rowData.createdDate ? moment(rowData.createdDate).format('MM/DD/YYYY'):'-';
                                                        }}

                                                    ]}
                                                    localization={{
                                                            body: { emptyDataSourceMessage: this.state.isLoading ==true
                                                                        ? "Loading..." : "No transaction log to display"
                                                                    }
                                                        }}
                                                    data={this.state.transactionList}
                                                    page={this.state.currentPage - 1}
                                                    totalCount={this.state.totalRecords}
                                                    isLoading={this.state.isLoading}
                                                    options={{
                                                        padding: "dense",
                                                        showTitle: false,
                                                        toolbar: false,
                                                        sorting: true,
                                                        actionsColumnIndex: -1,
                                                        search:false,
                                                        draggable: false,
                                                        pageSize: this.state.rowsPerPage,
                                                        cellStyle: {
                                                            padding: "10px",
                                                            color: '#575962',
                                                            fontSize: "13px",
                                                            fontWeight: "300"
                                                        },
                                                        headerStyle: {
                                                            backgroundColor: '#f4f3f8',
                                                            color: '#575962',
                                                            padding: "15px 10px",
                                                            fontSize: "13px",
                                                            fontWeight: "600"
                                                        },
                                                        emptyRowsWhenPaging:false,
                                                        paging: this.state.hidepageination,
                                                            pageSizeOptions: [5, 10, 20, 50, 100]
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </>
        )
      }
}

function mapStateToProps(state) {
  var parsedUserData = state.auth.user;
  var AuthToken = state.auth.authToken;
  let PtKey = '';

  return {
    dashboardData: state.auth.dashboardData,
    loading: state.auth.loading,
    PtKey: PtKey,
    AuthToken: AuthToken
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionLog);
